<template>
  <div
    class="unsubscribe-container"
    :class="{
      'loading': loading,
      'disabled': disabled,
      'unfollowed': !active,
    }"
    @click.stop="$emit('click')"
  >
    <div class="unsubscribe">
      {{ buttonLabel }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnsubscribeButton',
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    buttonLabel() {
      return this.active ? this.$t('common.unsubscribe') : this.$t('common.unsubscribed');
    },
  },
};
</script>

<style lang="sass" scoped>
  .unsubscribe-container
    width: 140px
    height: 35px
    position: absolute
    right: -1px
    bottom: -1px
    display: flex
    justify-content: flex-end
    align-items: center
    background-image: url('~@/assets/svg/subscribe/unsubscribe-button-default.svg')
    background-position: center
    background-repeat: no-repeat

    .unsubscribe
      padding-right: 23px
      font-weight: 500
      font-size: 14px
      line-height: 20px

    &:hover
      background-image: url('~@/assets/svg/subscribe/unsubscribe-button-hover.svg')
      cursor: pointer

    &:active,
    &.active
      background-image: url('~@/assets/svg/subscribe/unsubscribe-button-active.svg')

    &.disabled
      background-image: url('~@/assets/svg/subscribe/unsubscribe-button-disabled.svg')
      cursor: default

    &.unfollowed
      background-image: none
      opacity: 0.25
      cursor: default

      .unsubscribe
        margin-top: -12px
        font-weight: 400

    &.loading
      background-image: url('~@/assets/svg/subscribe/unsubscribe-button-loading.svg')
      cursor: wait
</style>
